import React, { Component } from "react";
import HotKeysModal from "Components/HotKeysModal";
import { langCheck, deepClone } from "Pub/js/utils";
import platform from "Pub/js/platform";
import { Input, InputNumber, Slider, Row } from "antd";
import { updateSelectCard } from "Store/ZoneSetting/action";
import { connect } from "react-redux";
import Notice from "Components/Notice";
const { NCRadio, NCSelect, NCCheckbox } = platform.base;
const Option = NCSelect.NCOption;
import "./index.less";
class WatermarkModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            preSelectCard: {}
        };
    }
    componentDidMount() {
        let { selectCard } = this.props;
        this.setState({
            preSelectCard: deepClone(selectCard)
        });
    }
    // change事件
    handleSelectCardChange = (value, key) => {
        let { selectCard } = this.props;
        selectCard = { ...selectCard };
        selectCard[key] = value;
        if (key === "watermarktype") {
            // 水印类型
            if (value == 0) {
                // 无水印
                selectCard.watermarktext = "";
                selectCard.watermarkfont = "";
                selectCard.position = "";
                selectCard.transparency = "";
            } else {
                // 文本水印
                selectCard.watermarktext = "";
                selectCard.watermarkfont = 0;
                selectCard.position = 0;
                selectCard.transparency = 0;
            }
        }
        this.props.updateSelectCard(selectCard);
    };
    // 弹窗ok事件
    handleOk = () => {
        let { selectCard, json } = this.props;
        // 校验
        if (selectCard.watermarktype == 1) {
            if (selectCard.watermarktext.length == 0) {
                Notice({
                    status: "warning",
                    msg: langCheck("ZoneSetting-000318", "pages", json)
                }); /* 国际化处理： 请输入内容*/
                return;
            } else if (selectCard.watermarktext.length > 20) {
                Notice({
                    status: "warning",
                    msg: langCheck("ZoneSetting-000319", "pages", json)
                }); /* 国际化处理： 内容长度不能超过20个字符*/
                return;
            }
        }
        this.props.handleSelectCardChange(selectCard);
        this.props.toggleFormula("watermark", false);
    };
    getSelectoption = () => {
        let { json } = this.props;
        const selectOption = {
            // 文字大小
            fontsizeOption: [
                { name: "正常", value: 0 },
                { name: "大", value: 1 },
                { name: "小", value: 2 }
            ],
            positionOption: [
                {
                    name: `${langCheck("ZoneSetting-000309", "pages", json) /* 国际化处理： 正下方:*/}`,
                    value: 0
                },
                { name: `${langCheck("ZoneSetting-000310", "pages", json) /* 国际化处理： 正上方:*/}`, value: 1 },
                { name: `${langCheck("ZoneSetting-000311", "pages", json) /* 国际化处理： 正左方:*/}`, value: 2 },
                { name: `${langCheck("ZoneSetting-000312", "pages", json) /* 国际化处理： 正右方:*/}`, value: 3 },
                {
                    name: `${langCheck("ZoneSetting-000313", "pages", json) /* 国际化处理： 左上方:*/}`,
                    value: 4
                },
                {
                    name: `${langCheck("ZoneSetting-000314", "pages", json) /* 国际化处理： 左下方:*/}`,
                    value: 5
                },
                {
                    name: `${langCheck("ZoneSetting-000315", "pages", json) /* 国际化处理： 右上方:*/}`,
                    value: 6
                },
                {
                    name: `${langCheck("ZoneSetting-000316", "pages", json) /* 国际化处理： 右下方:*/}`,
                    value: 7
                }
            ]
        };
        return selectOption;
    };
    renderTextMarkOption = () => {
        let { selectCard, json } = this.props;
        let { watermarktype } = selectCard;
        let disabled = watermarktype !== 1;
        return (
            <div className='textMark'>
                <Row>
                    <label>{langCheck("ZoneSetting-000304", "pages", json) /* 国际化处理： 内容:*/}</label>
                    <Input
                        disabled={disabled}
                        value={selectCard && selectCard.watermarktext}
                        onChange={e => {
                            this.handleSelectCardChange(e.target.value, "watermarktext");
                        }}
                        onBlur={e => {
                            this.handleSelectCardChange(e.target.value, "watermarktext");
                        }}
                        ref={input => (this[`input`] = input)}
                        onPressEnter={e => {
                            this[`input`].blur();
                        }}
                    />
                </Row>
                <Row>
                    <label>{langCheck("ZoneSetting-000305", "pages", json) /* 国际化处理： 字号:*/}</label>
                    <NCSelect
                        showClear={false}
                        disabled={disabled}
                        value={(selectCard && selectCard.watermarkfont) || 0}
                        onChange={value => {
                            this.handleSelectCardChange(value, "watermarkfont");
                        }}>
                        {this.getSelectoption().fontsizeOption.map((item, idx) => {
                            return (
                                <Option key={idx} value={item.value}>
                                    {item.name}
                                </Option>
                            );
                        })}
                    </NCSelect>
                    <label style={{ marginLeft: 20 }}>
                        {langCheck("ZoneSetting-000308", "pages", json) /* 国际化处理： 位置:*/}
                    </label>
                    <NCSelect
                        showClear={false}
                        disabled={disabled}
                        value={(selectCard && selectCard.position) || 0}
                        onChange={value => {
                            this.handleSelectCardChange(value, "position");
                        }}>
                        {this.getSelectoption().positionOption.map((item, idx) => {
                            return (
                                <Option key={idx} value={item.value}>
                                    {item.name}
                                </Option>
                            );
                        })}
                    </NCSelect>
                </Row>
                <Row>
                    <label>{langCheck("ZoneSetting-000307", "pages", json) /* 国际化处理： 透明度:*/}</label>
                    <InputNumber
                        min={0}
                        max={100}
                        step={1}
                        value={(selectCard && selectCard.watermarkalpha) || 0}
                        onChange={value => {
                            this.handleSelectCardChange(value, "watermarkalpha");
                        }}
                        disabled={disabled}
                    />
                    <Slider
                        min={0}
                        max={100}
                        onChange={value => {
                            this.handleSelectCardChange(value, "watermarkalpha");
                        }}
                        value={selectCard && typeof selectCard.watermarkalpha === "number" ? selectCard.watermarkalpha : 0}
                        step={1}
                        disabled={disabled}
                    />
                </Row>
            </div>
        );
    };
    // 渲染其他设置
    rendetOtherOption = () => {
        let { selectCard, json } = this.props;
        let { isshowplace, isshowtime } = selectCard;
        return (
            <div className='otherOption'>
                {langCheck("ZoneSetting-000301", "pages", json) /* 国际化处理： 其他设置*/}
                <NCCheckbox
                    className='dnd-cancel'
                    checked={isshowplace}
                    onChange={value => {
                        this.handleSelectCardChange(value, "isshowplace");
                    }}></NCCheckbox>
                <span>{langCheck("ZoneSetting-000302", "pages", json) /* 国际化处理： 显示地点*/}</span>
                <NCCheckbox
                    className='dnd-cancel'
                    checked={isshowtime}
                    onChange={value => {
                        this.handleSelectCardChange(value, "isshowtime");
                    }}></NCCheckbox>
                <span>{langCheck("ZoneSetting-000303", "pages", json) /* 国际化处理： 显示时间*/}</span>
            </div>
        );
    };
    render() {
        let { selectCard, visible, json } = this.props;
        let { preSelectCard } = this.state;
        console.log("selectCard========>", selectCard);
        console.log("preSelectCard========>", preSelectCard);
        return (
            <HotKeysModal
                maskClosable={true}
                customHeader={langCheck("ZoneSetting-000287", "pages", json)} /* 国际化处理： 水印*/
                visible={visible}
                onOk={() => {
                    this.handleOk();
                }}
                onCancel={() => {
                    this.props.handleSelectCardChange(preSelectCard);
                    this.props.toggleFormula("watermark", false);
                }}
                className='watermarkModal'>
                <div className='leftSide'>
                    <NCRadio.NCRadioGroup
                        selectedValue={selectCard && selectCard.watermarktype}
                        onChange={value => this.handleSelectCardChange(value, "watermarktype")}>
                        <NCRadio value={0}>
                            {langCheck("ZoneSetting-000298", "pages", json) /* 国际化处理： 无水印*/}
                        </NCRadio>
                        <br />
                        <NCRadio value={1}>
                            {langCheck("ZoneSetting-000299", "pages", json) /* 国际化处理： 文本水印*/}
                        </NCRadio>
                        {this.renderTextMarkOption()}
                        {this.rendetOtherOption()}
                    </NCRadio.NCRadioGroup>
                </div>
                <div className='rightSide'></div>
            </HotKeysModal>
        );
    }
}
export default connect(
    state => ({
        selectCard: state.zoneSettingData.selectCard
    }),
    {
        updateSelectCard
    }
)(WatermarkModal);
